// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_3BSii","text":"index_text_1W0ma","textHidden":"index_textHidden_2GJN6","contentBox":"index_contentBox_1HKT6","boxTitle":"index_boxTitle_aF2Nc"};